import { createContext } from 'react';
import { defaultState } from './defaultState';

const AnalyticsContext = createContext(defaultState);

export { AnalyticsContext };
